import * as React from 'react'

import { useProductOptionsTransformer } from '@thg-commerce/enterprise-components'
import { SubscriptionPaymentType } from '@thg-commerce/enterprise-components/ProductVariations/src/ProductVariations'
import { PurchaseOptions } from '@thg-commerce/enterprise-components/PurchaseOptions'
import { VariantFields as TransformerVariant } from '@thg-commerce/enterprise-components/src/transformer/productOptionsTransformer'
import { useSiteConfig } from '@thg-commerce/enterprise-core'
import { SelectedOptions } from '@thg-commerce/enterprise-network/src/ApolloProvider/resolvers/Query/Product/ProductPage'
import { SubscriptionContract } from '@thg-commerce/enterprise-network/src/generated/graphql'
import { useTheme } from '@thg-commerce/enterprise-pages/src/Product/theme'

interface AuroraPurchaseOptionsProps {
  // TODO REBUILD-8951 fix type any
  subscribeOptions?: {
    upfront: any[]
    onDispatch: any[]
  }
  onOptionChange?: (key: string, value: string) => void
  activeTabIndex: number
  selectedFrequencyId: string
  setSelectedFrequencyId: (id: string) => void
  onLinkedSkuOptionChange: (option: string) => void
  variants: TransformerVariant[]
  updateSelectedVariant: (variant) => void
  isSubscription?: boolean
  subscriptionPaymentType?: SubscriptionPaymentType
  subscriptionContracts?: SubscriptionContract[]
  selectedOptions?: SelectedOptions
  setActiveTabIndex?: (index: number) => void
  selectedVariant?: TransformerVariant
  defaultVariant?: TransformerVariant
  setSelectedOptionsCallback?: (option: SelectedOptions) => void
  enableSubscribeAndSaveInlinePricing?: boolean
  displaysPrices?: {
    oneTimePurchaseDisplayPrice?: string
    subscriptionDisplayPrice?: string
  }
}

export const AuroraPurchaseOptions = (props: AuroraPurchaseOptionsProps) => {
  const { showSavingsAmountOnSubscriptionCard } = useSiteConfig()
  const theme = useTheme()
  const productOptionsTransformer = useProductOptionsTransformer<
    TransformerVariant
  >()

  const productOptions = React.useMemo(
    () =>
      productOptionsTransformer({
        options: [],
        selectedOptions: props.selectedOptions,
        selectedOptionsChangedCallback: props.setSelectedOptionsCallback,
        variants: props.variants,
        variantChangedCallback: props.updateSelectedVariant,
        selectedVariant: props.selectedVariant,
        defaultVariant: props.defaultVariant,
      }),
    [props.selectedVariant?.sku, props.selectedOptions],
  )

  return (
    <React.Fragment>
      <PurchaseOptions
        isSubscription={props.isSubscription}
        subscribeOptions={props.subscribeOptions}
        subscriptionPaymentType={props.subscriptionPaymentType}
        subscriptionContracts={props.subscriptionContracts}
        selectedOptions={
          productOptions.selectedOptions ?? props.selectedOptions
        }
        onOptionChange={(option, optionValue) => {
          productOptions.onOptionChange(option, optionValue)
          props.onLinkedSkuOptionChange(option)
        }}
        purchaseOptionsStyle={theme.pageTheme.purchaseOptions}
        showSavingsAmountOnSubscriptionCard={
          showSavingsAmountOnSubscriptionCard
        }
        setActiveTabIndex={props.setActiveTabIndex}
        activeTabIndex={props.activeTabIndex}
        selectedFrequencyId={props.selectedFrequencyId}
        setSelectedFrequencyId={props.setSelectedFrequencyId}
        enableSubscribeAndSaveInlinePricing={
          props.enableSubscribeAndSaveInlinePricing
        }
        displaysPrices={props.displaysPrices}
      />
    </React.Fragment>
  )
}
